import { render, staticRenderFns } from "./CertiList.vue?vue&type=template&id=64492a78&scoped=true&"
import script from "./CertiList.vue?vue&type=script&lang=js&"
export * from "./CertiList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64492a78",
  null
  
)

export default component.exports